import link from '../../link/default';

const dark = (params) => link.dark(params);

export default dark;
